import { t } from '@citrite/translate';
import { Method } from 'Login/DSAuth/authentication';
import { AuthenticationMethod } from 'Login/DSAuth/authenticationController';

type AuthMethodStrings = {
	name: Method;
	title: string;
	switchText: string;
	error: string;
};

function initOnce(): AuthMethodStrings[] {
	return [
		{
			name: Method.SMARTCARD,
			title: t('Workspace:login.logon_text_smartcard'),
			switchText: t('Workspace:login.switch_to_smartcard'),
			error: t('Workspace:login.smartcard_auth_failure'),
		},
		{
			name: Method.PASSTHROUGH,
			title: t('Workspace:login.logon_text_passthrough'),
			switchText: t('Workspace:login.switch_to_generic'),
			error: t('Workspace:login.passthrough_auth_failure'),
		},
		{
			name: Method.EXPLICIT,
			title: t('Workspace:login.log_on'),
			switchText: t('Workspace:login.switch_to_explicit_auth'),
			error: t('Workspace:login.auth_failure'),
		},
	];
}

const authMethodStrings = initOnce();

export function getAuthMethodLogonText(currentMethod: AuthenticationMethod): string {
	const authMethodString = authMethodStrings.find(
		method => method.name === currentMethod?.name
	);
	return authMethodString ? authMethodString.title : t('Workspace:login.log_on');
}

export function getSwitchToAuthMethodText(currentMethod: AuthenticationMethod): string {
	const authMethodString = authMethodStrings.find(
		method => method.name === currentMethod?.name
	);
	return authMethodString
		? authMethodString.switchText
		: t('Workspace:login.switch_to_generic');
}

export function getAuthMethodErrorText(currentMethod: AuthenticationMethod): string {
	const authMethodString = authMethodStrings.find(
		method => method.name === currentMethod?.name
	);
	return authMethodString ? authMethodString.error : t('Workspace:login.auth_failure');
}
